export default "__VITE_ASSET__DSXdN8If__"